import { NgxPermissionsModule } from 'ngx-permissions';
// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
// Angular Material - individual entry points
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
// NgBootstrap
import { NgbProgressbarModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
// SVG inline
import { InlineSVGModule } from 'ng-inline-svg-2';
// Translation
import { TranslateModule } from '@ngx-translate/core';
// Loading bar
import { LoadingBarModule } from '@ngx-loading-bar/core';
// NGRX
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
// Ngx DatePicker
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
// Core Module
import { CoreModule } from '../../core/core.module';
import { HeaderComponent } from './header/header.component';
import { AsideLeftComponent } from './aside/aside-left.component';
import { FooterComponent } from './footer/footer.component';
import { SubheaderComponent } from './subheader/subheader.component';
import { BrandComponent } from './brand/brand.component';
import { TopbarComponent } from './header/topbar/topbar.component';
import { MenuHorizontalComponent } from './header/menu-horizontal/menu-horizontal.component';
import { PartialsModule } from '../partials/partials.module';
import { BaseComponent } from './base/base.component';
import { PagesModule } from '../pages/pages.module';
import { HtmlClassService } from './html-class.service';
import { HeaderMobileComponent } from './header/header-mobile/header-mobile.component';
import { ErrorPageComponent } from './content/error-page/error-page.component';
import { PermissionEffects, permissionsReducer, RoleEffects, rolesReducer } from '../../core/auth';

@NgModule({
    exports: [
        BaseComponent,
        FooterComponent,
        // headers
        HeaderComponent,
        BrandComponent,
        HeaderMobileComponent,
        // subheader
        SubheaderComponent,
        // topbar components
        TopbarComponent,
        // aside left menu components
        AsideLeftComponent,
        // horizontal menu components
        MenuHorizontalComponent,
        ErrorPageComponent,
    ],
    providers: [
        HtmlClassService,
    ],
    declarations: [
        BaseComponent,
        FooterComponent,
        // headers
        HeaderComponent,
        BrandComponent,
        HeaderMobileComponent,
        // subheader
        SubheaderComponent,
        // topbar components
        TopbarComponent,
        // aside left menu components
        AsideLeftComponent,
        // horizontal menu components
        MenuHorizontalComponent,
        ErrorPageComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        NgxPermissionsModule.forChild(),
        StoreModule.forFeature('roles', rolesReducer),
        StoreModule.forFeature('permissions', permissionsReducer),
        EffectsModule.forFeature([PermissionEffects, RoleEffects]),
        PagesModule,
        PartialsModule,
        CoreModule,
        FormsModule,
        MatProgressBarModule,
        MatMenuModule,
        MatDividerModule,
        MatTabsModule,
        MatButtonModule,
        MatTooltipModule,
        MatIconModule,
        TranslateModule.forChild(),
        LoadingBarModule,
        NgxDaterangepickerMd,
        // ng-bootstrap modules
        NgbProgressbarModule,
        NgbTooltipModule,
        InlineSVGModule,
    ]
})
export class ThemeModule {
}
